import React from "react";
import InputField from "components/atoms/InputField/InputField";
import { useIntl } from "react-intl";
import { useFormContext } from "react-hook-form";

interface LWHFieldsProps {
  isRequired: boolean;
}

function LWHFields({ isRequired }: LWHFieldsProps) {
  const intl = useIntl();
  const { setValue } = useFormContext();
  return (
    <>
      {/* Length input */}
      <div className="flex-row packing-list-add-item-input-small">
        <InputField
          label={intl.formatMessage({
            id: "new-request.packing-list.length",
            defaultMessage: "Length",
          })}
          placeholder={intl.formatMessage({
            id: "new-request.packing-list.length",
            defaultMessage: "Length",
          })}
          field_id="length"
          validations={{
            validate: {
              onlyNumber: (v: any) => !isNaN(v) || "Please enter a valid number",
            },
            setValueAs: (v: string) => (!v ? null : v),
            shouldUnregister: true,
          }}
          required={isRequired}
        />
      </div>
      {/* Width input */}
      <div className="flex-row packing-list-add-item-input-small">
        <InputField
          label={intl.formatMessage({
            id: "new-request.packing-list.width",
            defaultMessage: "Width",
          })}
          type="textinput"
          placeholder={intl.formatMessage({
            id: "new-request.packing-list.width",
            defaultMessage: "Width",
          })}
          field_id="width"
          validations={{
            validate: {
              onlyNumber: (v: any) => !isNaN(v) || "Please enter a valid number",
            },
            setValueAs: (v: string) => (!v ? null : v),
            shouldUnregister: true,
          }}
          required={isRequired}
        />
      </div>
      {/* Height input */}
      <div className="flex-row packing-list-add-item-input-small">
        <InputField
          label={intl.formatMessage({
            id: "new-request.packing-list.height",
            defaultMessage: "Height",
          })}
          type="textinput"
          placeholder={intl.formatMessage({
            id: "new-request.packing-list.height",
            defaultMessage: "Height",
          })}
          field_id="height"
          validations={{
            validate: {
              onlyNumber: (v: any) => !isNaN(v) || "Please enter a valid number",
            },
            setValueAs: (v: string) => (!v ? null : v),
            shouldUnregister: true,
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(`packing_list.temp.height`, e.target.value)}
          required={isRequired}
        />
      </div>
    </>
  );
}

export default LWHFields;
